var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1864 0.298712C15.4063 -0.396905 14.1384 0.19964 14.1384 1.29226V4.47103L1.16988 4.47034C0.486996 4.47034 0 4.9671 0 5.66203V9.3369C0 10.0325 0.487675 10.5286 1.16988 10.5286L14.1384 10.5293V13.7081C14.1384 14.8007 15.3083 15.3965 16.1864 14.7016L23.7921 8.54359C24.377 8.04682 24.377 7.05399 23.7921 6.55725L16.1864 0.298712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.6211e93331cfbb60dc2d97e87704f352.svg";
export { ForwardRef as ReactComponent };